import i18n from '@/i18n'
import {mesRequests} from '@/api'

const state = () => ({
    i18nProp: []
})

const getters = {
    i18nProp: (state) => state.i18nProp
}

const mutations = {
    setI18nProp (state, params) {
        // state.i18nProp = params.list
        let list = params.list
        for (let ele of list) {
            // console.log('ele', ele)
            i18n.mergeLocaleMessage(ele.language, ele.properties)
        }
    }
}

const actions = {
    async getI18nProp ({commit}, language) {
        let {data: list} = await getI18nPropData()
        commit('setI18nProp', {list})
    }
}

const getI18nPropData = (params) => {
    return new Promise((resolve) => {
        mesRequests.get({
            url: '/etao-system/i18n/get-i18n-prop-data',
            success: res => resolve(res)
        })
    })
}

export default {state, getters, mutations, actions}



// WEBPACK FOOTER //
// ./src/store/modules/i18nProp.js